import { FileSignature, Wifi, CreditCard, IdCard, Building2, User, FileCheck, MonitorCheck, Paperclip, type LucideIcon } from 'lucide-react';

// ⛔ ZERO EMOJI (lei visual da casa). Até 18/09/2026 cada tipo carregava um
// emoji (📄 📡 💳 🪪 🏢 👤 ✅ 📎) que aparecia no filtro, no cartão e no aviso de
// envio. Agora é ícone lucide, na cor muted — o mesmo vocabulário do resto do CRM.
export const TIPOS_ANEXO = [
  { value: 'CONTRATO_ASSINADO', label: 'Contrato Assinado', icon: FileSignature },
  { value: 'PRINT_COBERTURA', label: 'Print Cobertura', icon: Wifi },
  { value: 'PRINT_CREDITO', label: 'Print Crédito', icon: CreditCard },
  { value: 'DOC_REPRESENTANTE_LEGAL', label: 'Doc. Representante Legal', icon: IdCard },
  { value: 'CONTRATO_SOCIAL', label: 'Contrato Social', icon: Building2 },
  { value: 'DOC_CESSIONARIO', label: 'Doc. Cedente', icon: User },
  { value: 'PRINT_CONFIRMACAO_PROPOSTA', label: 'Print Confirmação Proposta', icon: FileCheck },
  { value: 'DOCUMENTOS_INPUT_FIXA', label: 'Documentos de Input Fixa', icon: MonitorCheck },
  { value: 'OUTROS', label: 'Outros', icon: Paperclip },
] as const;

export type TipoAnexo = typeof TIPOS_ANEXO[number]['value'];

export interface Anexo {
  id: string;
  cliente_id?: string;
  pedido_id?: string;
  nome: string;
  mime: string;
  tipo_extensao: string;
  tamanho: number;
  path: string;
  tipo_anexo: TipoAnexo;
  usuario_id: string;
  created_at: string;
  url?: string;
}

export function isImagemAnexo(mime: string): boolean {
  return mime.startsWith('image/');
}

export function formatarTamanho(bytes: number): string {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / 1048576).toFixed(1) + ' MB';
}

export function getLabelTipoAnexo(tipo: TipoAnexo): string {
  return TIPOS_ANEXO.find(t => t.value === tipo)?.label || tipo;
}

export function getIconTipoAnexo(tipo: TipoAnexo): LucideIcon {
  return TIPOS_ANEXO.find(t => t.value === tipo)?.icon || Paperclip;
}
